import { PharmaAddressDetails } from "@/redux/slice/location/interfaces/PharmaAddressDetails";
import { SpecifiedLocation } from "@/redux/slice/location/types/SpecifiedLocation";
import checkServiceAvailabilityApi from "@/redux/slice/location/apis/checkServiceAvailability";
import { updateSpecifiedLocation } from "@/redux/slice/location/slice";
import { setCartItems } from "@/redux/slice/cart/slice";

let pharmaDefObject: PharmaAddressDetails = {
  city: "",
  pincode: "",
  state: "",
  country: "",
  lat: "",
  lng: "",
  tatInput: "",
};

export const syncCart = async (dispatch: any) => {
  // cart items in local storage
  let storageCartItems = localStorage.getItem("cartItems");

  // address in storage
  let pharmaAddressObj: PharmaAddressDetails = localStorage.getItem("pharmaAddressDetails")
    ? JSON.parse(localStorage.getItem("pharmaAddressDetails"))
    : pharmaDefObject;
  // why tat availability here?

  if (!pharmaAddressObj?.tatInput && pharmaAddressObj?.pincode) {
    const data = await checkServiceAvailabilityApi({
      pincode: pharmaAddressObj?.pincode,
      latitude: Number(pharmaAddressObj?.lat),
      longitude: Number(pharmaAddressObj?.lng),
    });
    pharmaAddressObj = {
      ...pharmaAddressObj,
      tatInput: data?.tatInput,
    };
    localStorage.setItem("pharmaAddressDetails", JSON.stringify(pharmaAddressObj));
  }

  const specifiedLocation: SpecifiedLocation = {
    city: pharmaAddressObj?.city,
    country: pharmaAddressObj?.country,
    latitude: Number(pharmaAddressObj?.lat),
    longitude: Number(pharmaAddressObj?.lng),
    pincode: pharmaAddressObj?.pincode,
    state: pharmaAddressObj?.state,
    tatInput: pharmaAddressObj?.tatInput,
  };
  dispatch(updateSpecifiedLocation(specifiedLocation));
  dispatch(setCartItems(storageCartItems ? JSON.parse(storageCartItems) : []));
};
